// Contatos (WhatsApp) do CRM Lukos, via GET /api/state (snapshot local do CRM).
const CRM_API_URL = (import.meta.env.VITE_CRM_API_URL || 'http://localhost:3336').replace(/\/$/, '');

export interface CrmContact {
  id: string;
  jid?: string;
  name?: string;
  phone?: string;
  avatarUrl?: string;
  isGroup?: boolean;
  [key: string]: unknown;
}

export async function listarContatos(token: string): Promise<CrmContact[]> {
  const response = await fetch(`${CRM_API_URL}/api/state`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error('Erro ao consultar contatos do CRM');
  }
  const data = await response.json().catch(() => null);
  const contacts = Array.isArray(data?.contacts) ? data.contacts : [];
  // Contatos de grupo não são "clientes" — filtra pra sobrar só pessoa/empresa.
  return contacts.filter((c: CrmContact) => !c.isGroup && !String(c.jid ?? '').endsWith('@g.us'));
}

export default { listarContatos };
